import styled from "styled-components";
import TextFieldView from "../commons/TextField.view";
import BaseModal from "../modal/Base.modal";
import { useEffect, useState } from "react";
import { UserApi } from "../../api/User.api";
import Error from "../../models/Error.model";
import { ERROR_TYPE } from "../../commons/Const";


type PasswordResetProps = {
  onClickCancel: () => void
  onSuccess: () => void
}


export default function PasswordResetModal(props: PasswordResetProps) {

  const [originPassword, setOriginPassword] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')

  const [originPasswordMessage, setOriginPasswordMessage] = useState('')
  const [passwordMessage, setPasswordMessage] = useState('')
  const [confirmPasswordMessage, setConfirmPasswordMessage] = useState('')

  useEffect(() => {
    if(originPassword !== '') setOriginPasswordMessage('')
  }, [originPassword])

  useEffect(() => {
    if(password !== '') setPasswordMessage('')
  }, [password])

  useEffect(() => {
    if(confirmPassword === '') return

    if(password === confirmPassword) setConfirmPasswordMessage('')
    else setConfirmPasswordMessage('비밀번호가 일치하지 않습니다.')
  }, [password, confirmPassword])

  const resetPassword = () => {

    let isNext = true

    if(originPassword === '') {
      setOriginPasswordMessage('비밀번호를 입력해주세요.')
      isNext = false
    }

    if(password === '') {
      setPasswordMessage('비밀번호를 입력해주세요.')
      isNext = false
    }

    if(password !== confirmPassword) {
      setConfirmPasswordMessage('비밀번호가 일치하지 않습니다.')
      isNext = false
    }

    if(!isNext) return

    UserApi.resetPassword(originPassword, password)
    .then(result => {
      alert('비밀번호가 변경되었습니다.')
      props.onSuccess()
    }).catch(error => {
      console.log(error)
      if(error instanceof Error) {
        switch (error.code) {
          case ERROR_TYPE.INCORRECT_PASSWORD:
            setOriginPasswordMessage('기존 비밀번호가 일치하지 않습니다.')
            break;
        
          default:
            break;
        }
      }
    })

  }

  return (
    <BaseModal
      title="비밀번호 변경"
      onClickLeftButton={props.onClickCancel}
      onClickRightButton={resetPassword}
      rightButtonText="변경"
    >
      <PasswordResetdiv className="card_middle">

      <TextFieldView
          value={originPassword}
          onChange={setOriginPassword}
          title="기존 비밀번호"
          type="password"
          placeholder="기존 비밀번호"
          errorMessage={originPasswordMessage}
          styles={{
            marginBottom: 30
          }}
        />

        <TextFieldView
          value={password}
          onChange={setPassword}
          title="비밀번호"
          type="password"
          placeholder="비밀번호"
          errorMessage={passwordMessage}
          styles={{
            marginBottom: 30
          }}
        />

        <TextFieldView
          value={confirmPassword}
          onChange={setConfirmPassword}
          title="비밀번호 확인"
          type="password"
          placeholder="비밀번호 확인"
          errorMessage={confirmPasswordMessage}
        />
      </PasswordResetdiv>
    </BaseModal>
  )
}

const PasswordResetdiv = styled.section`
  
`